var PageAttributeType;
(function(PageAttributeType) {
    PageAttributeType["Airport"] = "airport";
    PageAttributeType["BookingAttribute"] = "bookingAttribute";
    PageAttributeType["Category"] = "category";
    PageAttributeType["City"] = "city";
    PageAttributeType["CityDistrict"] = "cityDistrict";
    PageAttributeType["Country"] = "country";
    PageAttributeType["Island"] = "island";
    PageAttributeType["Partner"] = "partner";
    PageAttributeType["Product"] = "product";
    PageAttributeType["RailStation"] = "railStation";
    PageAttributeType["State"] = "state";
})(PageAttributeType || (PageAttributeType = {}));
export { PageAttributeType };
